// === Status enums (alineados con CreditSICReport_GT del backend) ===

export type SICReportRunStatus = 'RUNNING' | 'COMPLETED' | 'COMPLETED_WITH_ERRORS' | 'FAILED';
export type SICAccountResultStatus = 'CONFIRMED' | 'REJECTED' | 'ERROR';
export type SICReportType = 'NEW' | 'UPDATE' | 'CLOSURE';
export type SICTrigger = 'CRON' | 'MANUAL';

// === Card 1: Estado actual ===

export interface SICReportStatus {
    report_id: string;
    partner_id: string;
    run_date: string;
    status: SICReportRunStatus;
    started_at: string;
    completed_at: string | null;
    eligible_count: number;
    skipped_count: number;
    sent_count: number;
    confirmed_count: number;
    rejected_count: number;
    error_count: number;
    trigger: SICTrigger;
    triggered_by: string | null;
}

// === Card 4: Historial ===

export type SICReportHistoryItem = SICReportStatus;

// === Drilldown: detalle de un reporte ===

export interface SICReportAccount {
    credit_id: string;
    directory_id: string;
    report_type: SICReportType;
    credit_status: 'ACTIVE' | 'DELINQUENT' | 'PAID_OFF';
    payload_hash: string;
    status: SICAccountResultStatus;
    cdc_folio: string | null;
    error_code: string | null;
    error_message: string | null;
    cdc_errors?: { errores: Array<{ codigo: string; mensaje: string }> };
    provider_response_raw?: Record<string, unknown>;
    sent_at: string;
    idempotency_key: string;
    // Payment metrics derivadas (opcionales — pueden no estar en items viejos)
    payment_history?: string[];          // ON_TIME, OVERDUE_1..7_PLUS, WRITTEN_OFF, NO_DATA
    total_reported_payments?: number;
    last_payment_at?: string;
    last_payment_amount?: number;
    outstanding_balance?: number;
    overdue_balance?: number;
    overdue_payments_count?: number;
    overdue_days?: number;
}

export interface SICReportDetail extends SICReportStatus {
    accounts: SICReportAccount[];
}

// === Card 3: Cuentas que requieren atencion ===

export interface SICAttentionItem extends SICReportAccount {}

// === Action: disparar corrida manual ===

export interface SICRunRequest {
    partnerId: string;
    runDate?: string;
    force?: boolean;
}

export interface SICRunResponse {
    reportId: string;
    partnerId: string;
    runDate: string;
    status: SICReportRunStatus;
    eligible: number;
    skipped: number;
    sent: number;
    confirmed: number;
    rejected: number;
    error: number;
}

export interface SICRunSkipped {
    skipped: true;
    reason: string;
}

export type SICRunResult = SICRunResponse | SICRunSkipped;

export function isSICRunSkipped(r: SICRunResult): r is SICRunSkipped {
    return (r as SICRunSkipped).skipped === true;
}
